/* global screen */

export function setDefaultResponsiveMode () {
  const rememberToken = Cookies.get('remember_token')
  let viewportMeta = document.getElementById('viewport-meta')

  if (isMobileDevice()) {  // mobile screen
    // when user open backoffice at the first time, or user do logout, it should be in responsive mode
    if (!isFullSiteMode() || rememberToken === undefined) {
      setResponsiveMode(true)
      // enable responsive
      viewportMeta.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no')
    } else {
      // disable responsive
      viewportMeta.setAttribute('content', 'width=1024')
      setResponsiveMode(false)
    }
  } else {  // desktop screen
    // set default view and responsive mode in desktop
    setResponsiveMode(true)
    viewportMeta.setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no')
  }
}

export function isFullSiteMode () {
  return Cookies.get('responsive_enabled') === 'false'
}

// Refer to this https://github.com/mokapos/moka-backoffice/blob/0c359135258b291c9bddb70f02adef11f120cfad/app/components/Layout/Layout.js#L18 for the number 991
export function isMobileDevice () {
  return screen.width <= 991
}

export function setResponsiveMode (responsive) {
  const expireTime = 365 // 1 year

  if (responsive) { // responsive === true
    Cookies.set('responsive_enabled', 'true', {path: '/', expires: expireTime})
  } else {
    Cookies.set('responsive_enabled', 'false', {path: '/', expires: expireTime})
  }
}



// WEBPACK FOOTER //
// ./app/utils/fullSite.js